module.exports = __webpack_public_path__ + "static/ray-dalio-d9b9a3bb5e52db743076e213b44533e8.jpg";